import automation from './automation.json'
import common from './common.json'
import role from './role.json'
import salesforce from './salesforce.json'
import settings from './settings.json'
import simplesimon from './simplesimon.json'
import user from './user.json'

export default {
  automation,
  common,
  role,
  salesforce,
  settings,
  simplesimon,
  user,
}
